import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3.072a8 8 0 0 1 2.32 11.834l5.387 5.387a1 1 0 0 1 -1.414 1.414l-5.388 -5.387a8 8 0 1 1 -.905 -13.249","key":"svg-0"}]]

/**
 * IconSearchFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItc2VhcmNoIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNCAzLjA3MmE4IDggMCAwIDEgMi4zMiAxMS44MzRsNS4zODcgNS4zODdhMSAxIDAgMCAxIC0xLjQxNCAxLjQxNGwtNS4zODggLTUuMzg3YTggOCAwIDEgMSAtLjkwNSAtMTMuMjQ5IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/search-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSearchFilled = createReactComponent('filled', 'search-filled', 'SearchFilled', __iconNode);

export default IconSearchFilled;